import { inIframe } from '../store/server'
export default {
  methods: {
    closeApplet () {
      if (typeof window === 'undefined' || !inIframe()) { return }
      parent.postMessage({ function: 'hideIframeMain' }, this.$route.query.origin)
    },
  },
}
